import { create } from 'zustand'

/**
 * 跨 Phase 的 UI 事件总线
 * Phase 2 写入事件 → Phase 1 MainHub 角色响应
 */
type UIEventStore = {
  /** 每次出牌 +1，用于触发角色动画 */
  playHandTrigger: number
  firePlayHand: () => void
}

export const useUIEventStore = create<UIEventStore>((set) => ({
  playHandTrigger: 0,
  firePlayHand: () => set((s) => ({ playHandTrigger: s.playHandTrigger + 1 })),
}))
